import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GiftsService } from '../../serivce/gifts.service';
import { ParentsService } from '../../serivce/parents.service';
@Component({
  selector: 'app-gifts-delete-dialog',
  templateUrl: './gifts-delete-dialog.component.html',
  styleUrls: ['./gifts-delete-dialog.component.css']
})
export class GiftsDeleteDialogComponent implements OnInit {
  datas;
  constructor(
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private router: Router,
    private toastr: ToastrService,
    private giftService: GiftsService,
  ) {
    this.datas = data;
  }

  ngOnInit() {

  }
  delGifts() {
    debugger
    var models = {
      id: this.datas.model.id
    }
    this.spinner.show();
    this.giftService.delGift(models).subscribe(res => {
      this.spinner.hide();
      if (res.status == 2) {
        this.toastr.success(res.content, "Thành công");
        this.dialogRef.close();
      }
      else {
        this.toastr.error(res.content, "Thất bại");
      }
    })
  }
  onNoClick() {
    this.dialogRef.close();
  }
}



